<ion-img [src]="img?.url ?? FALLBACK_IMG_URL" (ionError)="onImgError($event)" style="object-fit: contain;"></ion-img>